"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetApiResponsesResponseAllOfToJSON = exports.GetApiResponsesResponseAllOfFromJSONTyped = exports.GetApiResponsesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetApiResponsesResponseAllOfFromJSON(json) {
    return GetApiResponsesResponseAllOfFromJSONTyped(json, false);
}
exports.GetApiResponsesResponseAllOfFromJSON = GetApiResponsesResponseAllOfFromJSON;
function GetApiResponsesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiResponses': (json['apiResponses'].map(_1.ModelApiResponseFromJSON)),
    };
}
exports.GetApiResponsesResponseAllOfFromJSONTyped = GetApiResponsesResponseAllOfFromJSONTyped;
function GetApiResponsesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiResponses': (value.apiResponses.map(_1.ModelApiResponseToJSON)),
    };
}
exports.GetApiResponsesResponseAllOfToJSON = GetApiResponsesResponseAllOfToJSON;
